import { useBreakpoint } from "./useBreakpoint.js";
import { breakpoints } from "../theme/grid.js";
const useIsMobileBreakpoint = () => {
  const breakpoint = useBreakpoint();
  return breakpoint < breakpoints.md;
};
export {
  useIsMobileBreakpoint
};
//# sourceMappingURL=useIsMobileBreakpoint.js.map
